import React, { useCallback, useEffect, useMemo, useRef } from 'react';
var Modal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, size = _a.size, closeOnEscape = _a.closeOnEscape, isBackdropColor = _a.isBackdropColor, className = _a.className, children = _a.children, isModalAdmin = _a.isModalAdmin, classNameWrapper = _a.classNameWrapper;
    var escFunction = useCallback(function (event) {
        if (event.keyCode === 27) {
            onClose && onClose();
        }
    }, [onClose]);
    var closeModal = useCallback(function () {
        onClose();
        document.removeEventListener('keydown', escFunction, false);
    }, [escFunction, onClose]);
    var onClickContent = useCallback(function (evt) {
        evt.stopPropagation();
    }, []);
    var backdropRef = useRef();
    var onClickBackdrop = useCallback(function (evt) {
        var _a, _b;
        var path = null;
        if (evt.nativeEvent.path) {
            if (evt.nativeEvent.composedPath) {
                path = ((_a = evt === null || evt === void 0 ? void 0 : evt.nativeEvent) === null || _a === void 0 ? void 0 : _a.path[0]) || evt.nativeEvent.composedPath;
            }
            else {
                path = (_b = evt === null || evt === void 0 ? void 0 : evt.nativeEvent) === null || _b === void 0 ? void 0 : _b.path[0];
            }
        }
        else if (evt.nativeEvent.composedPath) {
            path = evt.nativeEvent.composedPath()[0];
        }
        else {
            path = null;
            console.log('Supports neither `path` nor `composedPath`');
        }
        if (!!onClose && path && path === (backdropRef === null || backdropRef === void 0 ? void 0 : backdropRef.current)) {
            closeModal();
        }
    }, [onClose, closeModal]);
    var onScroll = useCallback(function (evt) {
        evt.stopPropagation();
    }, []);
    useEffect(function () {
        if (isOpen) {
            var newCloseOnEscape = closeOnEscape !== undefined ? closeOnEscape : true;
            if (newCloseOnEscape) {
                document.addEventListener('keydown', escFunction, false);
            }
        }
    }, [closeOnEscape, escFunction, isOpen]);
    var renderContent = useMemo(function () {
        var newIsBackdropColor = isBackdropColor;
        if (isBackdropColor === null || isBackdropColor === undefined) {
            newIsBackdropColor = true;
        }
        var classNameResult = 'gr-modal ' +
            (isOpen ? 'open ' : ' ') +
            (newIsBackdropColor ? 'backdrop-color ' : ' ') +
            (classNameWrapper ? classNameWrapper : ' ');
        return (React.createElement("div", { ref: backdropRef, className: classNameResult, onMouseDown: function (event) {
                onClickBackdrop(event);
            } },
            React.createElement("div", { className: 'gr-modal-content ' +
                    (isModalAdmin ? 'gr-modal-content-admin ' : '') +
                    (size ? size + ' ' : ' ') +
                    (className ? className : ' '), onClick: onClose ? onClickContent : undefined, onScroll: onScroll }, children)));
    }, [
        isBackdropColor,
        isOpen,
        classNameWrapper,
        onClickBackdrop,
        isModalAdmin,
        size,
        className,
        onClose,
        onClickContent,
        onScroll,
        children,
    ]);
    return React.createElement(React.Fragment, null, renderContent);
};
export { Modal };
//# sourceMappingURL=Modal.js.map